import { Action } from 'redux';

export const SHOW_BILLING_SUMMARIES_OPTION_MODAL = 'billing-summaries/SHOW_BILLING_SUMMARIES_OPTION_MODAL';
export const HIDE_BILLING_SUMMARIES_OPTION_MODAL = 'billing-summaries/HIDE_BILLING_SUMMARIES_OPTION_MODAL';

export const SHOW_BILLING_SUMMARIES_EXPORT_MODAL = 'billing-summaries/SHOW_BILLING_SUMMARIES_EXPORT_MODAL';
export const HIDE_BILLING_SUMMARIES_EXPORT_MODAL = 'billing-summaries/HIDE_BILLING_SUMMARIES_EXPORT_MODAL';

export const SHOW_BILLING_SUMMARIES_PERMIT_ORDER_MODAL = 'billing-summaries/SHOW_BILLING_SUMMARIES_PERMIT_ORDER_MODAL';
export const HIDE_BILLING_SUMMARIES_PERMIT_ORDER_MODAL = 'billing-summaries/HIDE_BILLING_SUMMARIES_PERMIT_ORDER_MODAL';

export const showBillingSummariesOptionModal = () => {
  return {
    type: SHOW_BILLING_SUMMARIES_OPTION_MODAL,
  };
};

export const hideBillingSummariesOptionModal = () => {
  return {
    type: HIDE_BILLING_SUMMARIES_OPTION_MODAL,
  };
};

export const showBillingSummariesExportModal = () => {
  return {
    type: SHOW_BILLING_SUMMARIES_EXPORT_MODAL,
  };
};

export const hideBillingSummariesExportModal = () => {
  return {
    type: HIDE_BILLING_SUMMARIES_EXPORT_MODAL,
  };
};

export const showBillingSummariesPermitOrderModal = () => {
  return {
    type: SHOW_BILLING_SUMMARIES_PERMIT_ORDER_MODAL,
  };
};

export const hideBillingSummariesPermitOrderModal = () => {
  return {
    type: HIDE_BILLING_SUMMARIES_PERMIT_ORDER_MODAL,
  };
};

export interface ShowBillingSummariesOptionModalAction extends Action<typeof SHOW_BILLING_SUMMARIES_OPTION_MODAL> {}
export interface HideBillingSummariesOptionModalAction extends Action<typeof HIDE_BILLING_SUMMARIES_OPTION_MODAL> {}

export interface ShowBillingSummariesExportModalAction extends Action<typeof SHOW_BILLING_SUMMARIES_EXPORT_MODAL> {}
export interface HideBillingSummariesExportModalAction extends Action<typeof HIDE_BILLING_SUMMARIES_EXPORT_MODAL> {}

export interface ShowBillingSummariesPermitOrderModalAction extends Action<
  typeof SHOW_BILLING_SUMMARIES_PERMIT_ORDER_MODAL
> {}
export interface HideBillingSummariesPermitOrderModalAction extends Action<
  typeof HIDE_BILLING_SUMMARIES_PERMIT_ORDER_MODAL
> {}

export type BillingSummariesAction =
  | ShowBillingSummariesOptionModalAction
  | HideBillingSummariesOptionModalAction
  | ShowBillingSummariesExportModalAction
  | HideBillingSummariesExportModalAction
  | ShowBillingSummariesPermitOrderModalAction
  | HideBillingSummariesPermitOrderModalAction;
